import {css} from 'styled-components';

export default css`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  flex-wrap: wrap;
  height: 100%;
  align-items: flex-start;
  width: max-content;
  min-width: 0;
`
